import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {RadioButton, Table} from "@wfp/ui";
import {KVPair, ListPage, Sortable, UserDetails} from "../../models/types";
import {datetimeParse} from "../../hooks/formats";
import {TablePagination} from "../commons/table-pagination/table-pagination";

interface Props {
    hidePagination?: boolean;
    page: ListPage<UserDetails>;
    loadPage: (page: number, pageSize?: number, filtering?: KVPair[], sorting?: string[]) => void;
    onSelectUser?: (id: number) => void;
    onClick: (id: number) => void;
    sort?: (field: string) => void;
    sortInfo?: Sortable[];
}

const Headers = ['name', 'email', 'entity', 'role', 'last_modified'];

export function UserTable(props: Props) {
    const {t} = useTranslation();
    const [sortables, setSortables] = useState<Sortable[]>();

    useEffect(() => {
        if (!!props.sortInfo) {
            const sorts = Headers.map((header) => {
                const sort = props.sortInfo?.find((sort) => sort.code === header);
                return !!sort ? sort : {code: header, field: header, mode: 0, enabled: false}
            });
            setSortables(sorts);
        }
    }, [props.sortInfo]);

    function handleSorting(idx: number) {
        if (!!sortables && !!props.sort) {
            const sortable = sortables[idx];
            if (!sortable.enabled) {
                return;
            }
            sortable.mode = (sortable.mode + 1) % 3;
            setSortables([...sortables]);
            const value = sortable.mode === 1 ? `+${sortable.field}` : sortable.mode === 2 ? `-${sortable.field}` : sortable.field;
            props.sort(value);
        }
    }

    return (
        <div>
            <Table>
                <thead>
                <tr className="item-row-head">
                    {Headers.map((header, idx) => (
                        <th key={idx} onClick={() => handleSorting(idx)} className={props.sort && sortables?.at(idx)?.enabled ? "cursor-pointer" : ""}>
                            {t(header)}
                        {!!sortables?.length && (
                            <span className="ml-0.5">
                                {sortables[idx].mode === 2 ? '\u25bc' : sortables[idx].mode === 0 ? '\u2000' : '\u25b2'}
                            </span>
                        )}
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {props.page.results.map((item: UserDetails) => (
                    <tr className="item-row cursor-pointer" key={item.pk}>
                        <td className="item-col text-start" onClick={() => props.onClick(item.pk)}>
                            {item.firstName} {item.lastName}
                        </td>
                        <td className="item-col text-start" onClick={() => props.onClick(item.pk)}>
                            {item.email}
                        </td>
                        <td className="item-col text-start p-0.5" onClick={() => props.onClick(item.pk)}>
                            {item.entityName || ""}
                        </td>
                        <td className="item-col text-start" onClick={() => props.onClick(item.pk)}>
                            {t(item.role)}
                        </td>
                        <td className="item-col text-start" onClick={() => props.onClick(item.pk)}>
                            {!!item.updatedOn ? datetimeParse(item.updatedOn) : ''}
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
        {!props.hidePagination && (
            <TablePagination page={props.page} loadPage={props.loadPage}/>
        )}
        </div>
    )
}
